/**
 * MethodScript Syntax Definitions
 *
 * This file provides utility functions for working with MethodScript syntax.
 * The actual keyword and command lists are auto-generated from command-parameters.json.
 *
 * IMPORTANT: Do not manually edit keyword/command lists here.
 * They are generated from PalmSens.MethodScript/Grammar/command-parameters.json
 * Run `npm run generate` to regenerate the syntax data.
 */

// Import generated syntax data
export { controlKeywords, measurementCommands, standardCommands, operators, allCommands, allKeywords } from './generated/syntax-data.js';

/**
 * Get regex pattern for a list of keywords
 */
export function getKeywordPattern(keywords: ReadonlyArray<string>): string {
    if (keywords.length === 1) {
        return `\\b${keywords[0]}\\b`;
    }
    return `\\b(${keywords.join('|')})\\b`;
}

/**
 * Split keywords into chunks for better regex readability
 * Max 6 keywords per chunk
 */
export function chunkKeywords(keywords: ReadonlyArray<string>, chunkSize = 6): Array<Array<string>> {
    const result: Array<Array<string>> = [];
    for (let i = 0; i < keywords.length; i += chunkSize) {
        result.push([...keywords.slice(i, i + chunkSize)]);
    }
    return result;
}
